// Copyright (c) 2017 Deere & Company

import * as helpers from '../helpers';
import {
    FormattedMessage,
    injectIntl,
    intlShape
} from 'react-intl';
import React, {
    Component,
    PropTypes
} from 'react';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import LabeledNode from '../../../../shared/components/labeled-node';
import {Link} from 'react-router';
import OptionsDropDown from '../../../../shared/components/options-drop-down';
import RecoveryPercentageIcon from '../recovery-percentage-icon';
import ReimbursementSummaryLeadAccount from '@deere/cps-it.warranty-model-factory/lib/reimbursement-summary-lead-account';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyDateRangePicker from '../../../../shared/components/warranty-date-range-picker/warranty-date-range-picker';
import {buildNumber} from '../../../../shared/services/build-number';

const queryString = props =>
    `postingDateFrom=${props.selectedPostingDate.postingDateFrom}&postingDateTo=${props.selectedPostingDate.postingDateTo}`;

class ReimbursementSummaryDropdown extends Component {

    state = {
        isCustomRange: false,
        options: [
            {
                key: 'MTD',
                value: this.props.intl.formatMessage({id: 'MONTH_TO_DATE'})
            },
            {
                key: 'PM',
                value: this.props.intl.formatMessage({id: 'PREVIOUS_MONTH'})
            },
            {
                key: 'R12M',
                value: this.props.intl.formatMessage({id: 'ROLLING_12_MONTHS'})
            },
            {
                key: 'CUSTOM_RANGE',
                value: this.props.intl.formatMessage({id: 'CUSTOM_RANGE'})
            }
        ],
        selectedValue: '',
        totals: helpers.computeTotals(this.props.leadAccounts)
    };

    componentWillMount = () => {

        this.setState({
            selectedValue: this.props.selectedValue ? this.props.selectedValue : 'MTD'
        });

        this.setState({
            isCustomRange: this.props.selectedValue === 'CUSTOM_RANGE'
        });

    };

    componentWillReceiveProps = nextProps => {

        this.setState({
            totals: helpers.computeTotals(nextProps.leadAccounts)
        });

    };

    handlePostingDateChange = newPostingDate => {

        this.props.onSelectedValueChange(newPostingDate);

        if (newPostingDate === 'CUSTOM_RANGE') {

            this.setState({
                isCustomRange: true,
                selectedValue: newPostingDate
            });

        } else {

            const postingDateRange = helpers.getReimbursementSummaryPostingDateValues[newPostingDate](new Date());

            this.props.onPostingDateChange(postingDateRange);

            this.setState({
                isCustomRange: false,
                selectedValue: newPostingDate
            });

        }

    };

    handleCustomRangeChange = newValue => {

        if (newValue.from && newValue.to) {

            this.props.onPostingDateChange({
                postingDateFrom: newValue.from,
                postingDateTo: newValue.to
            });

        }

    };

    render = () => {

        const totalRecoveryPercentage = helpers.computeTotalRecoveryPercentage(this.state.totals.totalApproved, this.state.totals.totalRequested);

        const recoveryPercentageDisplay = isNaN(totalRecoveryPercentage) ?
                                            '--' :
                                            (<FormattedMessage
                                                id='PERCENTAGE_SYMBOL'
                                                values={{
                                                    percentage: buildNumber(totalRecoveryPercentage)
                                                }}
                                             />);

        return (
            <section className='reimbursement-summary-dropdown-panel'>
                <div className='title'>
                    <FormattedMessage id='REIMBURSEMENT_SUMMARY'/>
                    <RecoveryPercentageIcon recoveryPercentage={totalRecoveryPercentage}/>
                </div>
                <Link
                    className='view-all'
                    to={`/reimbursement-summary/all?${queryString(this.props)}`}
                >
                    <FormattedMessage id='CLICK_TO_VIEW_ALL'/>
                </Link>
                <OptionsDropDown
                    className='reimbursement-summary-dropdown'
                    isPlaceholderTranslated={false}
                    onChange={this.handlePostingDateChange}
                    optionDisplayAttributes={['value']}
                    optionKey='key'
                    options={this.state.options}
                    placeholder='SELECT_A_RANGE'
                    selectedValue={this.state.selectedValue}
                />
                {this.state.isCustomRange &&
                    <WarrantyDateRangePicker
                        dateRange={new DateRange({
                            from: this.props.selectedPostingDate.postingDateFrom,
                            to: this.props.selectedPostingDate.postingDateTo
                        })}
                        maxDate={null}
                        minDate={null}
                        onDateChange={this.handleCustomRangeChange}
                    />
                }
                <LabeledNode
                    className='recovery-percentage'
                    data={recoveryPercentageDisplay}
                    label='RECOVERY'
                />

                <LabeledNode
                    className='total-unpaid'
                    data={buildNumber(this.state.totals.totalUnpaid, this.context.user.settings.general.decimalFormat.key)}
                    label='TOTAL_UNPAID'
                />
            </section>
        );

    };

}

ReimbursementSummaryDropdown.displayName = 'ReimbursementSummaryDropdown';
ReimbursementSummaryDropdown.propTypes = {
    intl: intlShape.isRequired,
    leadAccounts: PropTypes.arrayOf(PropTypes.instanceOf(ReimbursementSummaryLeadAccount)).isRequired,
    onPostingDateChange: PropTypes.func.isRequired,
    onSelectedValueChange: PropTypes.func.isRequired,
    selectedPostingDate: PropTypes.object.isRequired,
    selectedValue: PropTypes.string.isRequired
};
ReimbursementSummaryDropdown.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default injectIntl(ReimbursementSummaryDropdown);



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/components/reimbursement-summary-aside/reimbursement-summary-dropdown.js